import { useCallback, useMemo, useState } from 'react';

type StepCounterHook = {
  currentStep: number;
  incrementSteps: () => void;
  decrementSteps: () => void;
  resetSteps: () => void;
  isLastStep: boolean;
  goToStep: (step: number) => void;
};

export const useStepCounter = (stepsCount: number, initialValue = 0): StepCounterHook => {
  const [currentStep, setCurrentStep] = useState(initialValue);

  const incrementSteps = useCallback(() => setCurrentStep((prevState) => prevState + 1), [currentStep]);
  const decrementSteps = useCallback(() => setCurrentStep((prevState) => prevState - 1), [currentStep]);
  const resetSteps = useCallback(() => setCurrentStep(initialValue), []);
  const isLastStep = useMemo(() => currentStep === stepsCount - 1, [currentStep, stepsCount]);
  const goToStep = useCallback((step: number) => setCurrentStep(step), []);

  return {
    currentStep,
    incrementSteps,
    decrementSteps,
    resetSteps,
    isLastStep,
    goToStep,
  } as const;
};
